import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"
import {ClearButton, ClearButtonDesktop, ContentContainerProps, GridWrapper} from "../../../components"

export const StyledGridWrapper = styled(GridWrapper)`
    @media (min-width: ${breakpoints.values.md}px) {
        border-right: none;
    }
`

export const Container = styled("div")`
    pointer-events: none;
    touch-action: none;
    & * {
        pointer-events: auto;
        touch-action: auto;
    }
    background: ${({theme}) => theme.uxfabric.components.menu.searchMenu.default.backgroundColor};
`

export const ContentContainer = styled("div", {
    shouldForwardProp: p => p !== "isNoResults" && p !== "isRecentSearches",
})<ContentContainerProps>`
    @media (min-width: ${breakpoints.values.md}px) {
        padding: 1.5rem 0 1rem 3.5rem;
    }

    background: ${({theme}) => theme.uxfabric.components.menu.searchMenu.default.backgroundColor};
    width: 100%;
    height: auto;
    min-height: ${({isNoResults, isRecentSearches}) => (isNoResults || isRecentSearches ? "0rem" : "25.125rem")};
`

export const ClearButtonDesktopWrapper = styled("div")`
    width: 100%;
    text-align: end;
    padding-right: 3.5rem;
    padding-top: 1.5rem;
    background: ${({theme}) => theme.uxfabric.components.menu.searchMenu.default.backgroundColor};
`

export const StyledClearButtonDesktop = styled(ClearButtonDesktop)`
    text-decoration: underline;
`

export const StyledClearButton = styled(ClearButton)`
    text-decoration: underline;
`

export const HeaderContainer = styled("div")`
    align-items: center;
    border-top: 0.0625rem solid ${({theme}) => theme.uxfabric.components.card.cardHeader.default.borderColor};
    border-bottom: 1px solid ${({theme}) => theme.uxfabric.components.card.cardHeader.default.borderColor};
    color: ${({theme}) => theme.uxfabric.text.primary};
    background: ${({theme}) => theme.uxfabric.components.card.cardHeader.default.backgroundColor};

    @media (max-width: ${breakpoints.values.md - 1}px) {
        padding: 0.75rem 1rem;
    }

    @media (min-width: ${breakpoints.values.md}px) {
        background: transparent;
        border: none;
    }
`
